import { getRequestCredentials } from "@prismicio/editor-support/Http"

import { env } from "../../env"
import { getRepositoryName } from "../../routing"
import { ABMLandingPagesApiClient } from "./ABMLandingPagesApiClient"
import { ProductLandingPageApiClient } from "./ProductLandingPageApiClient"

export * from "./ABMLandingPagesApiClient"
export * from "./LandingPagesApiClient"
export * from "./ProductLandingPageApiClient"

export const productLandingPagesApiClient = new ProductLandingPageApiClient({
  baseUrl: new URL(env.PRISMIC_LAB_PRODUCT_LANDING_PAGES_BASE_URL),
  repository: getRepositoryName(),
  credentials: getRequestCredentials(env.PRISMIC_PAGE_BUILDER_AUTH_STRATEGY),
})

export const abmLandingPagesApiClient = new ABMLandingPagesApiClient({
  baseUrl: env.PRISMIC_LAB_ABM_LANDING_PAGES_BASE_URL,
  repository: getRepositoryName(),
  credentials: getRequestCredentials(env.PRISMIC_PAGE_BUILDER_AUTH_STRATEGY),
})
